// @flow
import React from 'react'
import styled from 'styled-components'
import media from '../../../../styles/media'
import PropertyCard from '../../../../components/PropertyCard'

const Component = styled.div`
  width: 100%;
  padding: 0 1rem;

  ${media.mdUp} {
    width: 50%;
  }
`

type Props = {
  property: Object
}

const SearchResult = ({ property }: Props) => (
  <Component>
    <PropertyCard key={property.mlsId} property={property} />
  </Component>
)

export default SearchResult



// WEBPACK FOOTER //
// ./src/views/Search/components/SearchResult/index.js